import React from 'react';

export default function HealthCommunity() {
  return (
    <div className="p-4 text-center">
      <h2 className="text-xl font-bold mb-2">Health Community</h2>
      <p className="text-gray-500">Live community chat is currently unavailable. Please use the Private Chat Room for real-time chat.</p>
    </div>
  );
}